var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CookieEnum, DestinationEnum } from './types/enums';
import { getCookie } from './getCookie';
export var mapAdobe = function (initParams) {
    var _a;
    validateAdobeParam(initParams);
    if (!initParams.adobe)
        return undefined;
    return {
        businessUnit: initParams.adobe.businessUnit,
        subBrand: initParams.adobe.subBrand,
        identityCookiesEnabled: initParams.adobe.identityCookiesEnabled,
        identityCookies: mapIdentityCookies((_a = initParams.adobe) === null || _a === void 0 ? void 0 : _a.identityCookies, initParams.adobe.identityCookiesEnabled),
        adobeEnv: initParams.adobe.adobeEnv,
    };
};
function validateAdobeParam(initParams) {
    if (initParams.destinations.includes(DestinationEnum.Adobe) && initParams.adobe === undefined) {
        throw Error('Failed to initialize web-behavior-tracker. initParams.adobe is mandatory if you want to send data to Adobe');
    }
}
export var mapIdentityCookies = function (identityCookies, identityCookiesEnabled) {
    var _a, _b, _c;
    var _d, _e, _f, _g, _h, _j;
    if (!identityCookiesEnabled) {
        return _a = {},
            _a[CookieEnum.AdobeIdentity] = '',
            _a[CookieEnum.AdobeAmcv] = '',
            _a;
    }
    if (identityCookies === undefined) {
        return _b = {},
            _b[CookieEnum.AdobeIdentity] = (_d = getCookie(CookieEnum.AdobeIdentity)) !== null && _d !== void 0 ? _d : '',
            _b[CookieEnum.AdobeAmcv] = (_e = getCookie(CookieEnum.AdobeAmcv)) !== null && _e !== void 0 ? _e : '',
            _b;
    }
    else {
        return __assign(__assign({}, identityCookies), (_c = {}, _c[CookieEnum.AdobeIdentity] = (_g = (_f = identityCookies[CookieEnum.AdobeIdentity]) !== null && _f !== void 0 ? _f : getCookie(CookieEnum.AdobeIdentity)) !== null && _g !== void 0 ? _g : '', _c[CookieEnum.AdobeAmcv] = (_j = (_h = identityCookies[CookieEnum.AdobeAmcv]) !== null && _h !== void 0 ? _h : getCookie(CookieEnum.AdobeAmcv)) !== null && _j !== void 0 ? _j : '', _c));
    }
};
//# sourceMappingURL=mapAdobe.js.map